/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICommerceApiSettings,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';
import { SortColumn } from '@msdyn365-commerce/retail-proxy';
import { getSearchConfigurationAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/StoreOperationsDataActions.g';

import { buildCacheKey } from '.';

// TODO: import from commerce entities when available
// eslint-disable-next-line @typescript-eslint/naming-convention
interface SearchConfiguration {
    ProductSortColumns?: SortColumn[];
}

/**
 * Action Input class for the getSearchConfiguration data action.
 */
export class SearchConfigurationInput implements IActionInput {
    private readonly apiSettings: ICommerceApiSettings;

    constructor(apiSettings: ICommerceApiSettings) {
        this.apiSettings = apiSettings;
    }

    public getCacheKey = () => buildCacheKey('SearchConfig', this.apiSettings);

    public getCacheObjectType = () => 'SearchConfiguration';

    public dataCacheType = (): CacheType => 'request';
}

/**
 * Creates the input required to make the retail api call.
 * @param inputData
 */
export const createSearchConfigurationInput = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new SearchConfigurationInput(inputData.requestContext.apiSettings);
};

/**
 * Calls the Retail API.
 * @param input
 * @param ctx
 */
export async function getSearchConfigurationAction(input: SearchConfigurationInput, ctx: IActionContext): Promise<SearchConfiguration> {
    return getSearchConfigurationAsync({ callerContext: ctx });
}

export const getSearchConfigurationActionDataAction = createObservableDataAction({
    id: '@msdyn365-commerce-modules/retail-actions/get-search-configurations',
    action: <IAction<SearchConfiguration>>getSearchConfigurationAction,
    input: createSearchConfigurationInput
});

export default getSearchConfigurationActionDataAction;
